<template>
  <div class="m-5 md:m-15 2xl:m-20">
    <h3
      id="form-intitule"
      class="mb-15 2xl:mb-20 w-full"
    >
      Identification du titulaire
    </h3>

    <!-- BEGIN Identification du titulaire -->
    <div class="grid grid-cols-12 gap-x-4 gap-y-10">
      <multiple-field
        :value="form.prenom"
        class="md:col-span-3"
        label="Prénom"
      />

      <multiple-field
        :value="form.nom"
        class="md:col-span-3"
        label="Nom"
      />

      <multiple-field
        :value="form.date_naissance"
        label="Date de naissance"
        class="col-span-full md:col-span-3"
      />

      <multiple-field
        :value="form.genre"
        class="md:col-span-3"
        label="Genre"
      />

      <multiple-field
        :value="form.situation"
        class="md:col-span-3"
        label="Situation familliale"
      />

      <multiple-field
        :value="form.telephone"
        class="md:col-span-3"
        label="Téléphone"
      />

      <multiple-field
        :value="form.email"
        class="md:col-span-3"
        label="Email"
      />

      <multiple-field
        :value="form.website"
        class="md:col-span-3"
        label="Site internet personnel"
      />

      <multiple-field
        :value="form.adresse"
        class="md:col-span-6 md:row-span-2"
        label="Adresse complète"
        grows-vertically
      />

      <multiple-field
        :value="form.hebergement"
        class="md:col-span-3"
        label="Hébergement"
      />

      <multiple-field
        :value="form.hebergement_precis"
        class="md:col-span-3"
        label="Autre hébergement"
      />

      <multiple-field
        :value="form.niveau"
        class="lg:col-start-1 md:col-span-3"
        label="Niveau de formation"
      />

      <multiple-field
        :value="form.niveau_precis"
        class="md:col-span-3"
        label="Autre niveau de formation"
      />

      <multiple-field
        :value="form.dernier_diplome"
        class="md:col-span-3"
        label="Dernier diplôme obtenu"
      />

      <multiple-field
        :value="form.moyen_transport"
        class="lg:col-start-1 md:col-span-3"
        label="Moyen de déplacement"
      />

      <multiple-field
        :value="form.moyen_transport_precis"
        class="md:col-span-3"
        label="Autre moyen de transport"
      />

      <multiple-field
        :value="form.permis"
        class="md:col-span-3"
        label="Permis de conduire"
      />

      <multiple-field
        :value="form.permis_precis"
        class="md:col-span-3"
        label="Autre permis"
      />

      <multiple-field
        :value="form.type_revenus"
        class="lg:col-start-1 md:col-span-3"
        label="Type de revenus"
      />

      <multiple-field
        :value="form.type_revenus_precis"
        class="md:col-span-3"
        label="Autre type de revenus"
      />

      <multiple-field
        :value="form.titre_sejour"
        class="md:col-span-3"
        label="Carte de séjour"
      />
    </div>
    <!-- END Identification du titulaire -->

    <!-- BEGIN Informations générales -->
    <h3
      id="form-infos-generales"
      class="my-16 xxl:my-20 2xl:my-22"
    >
      Informations générales
    </h3>

    <div class="grid grid-cols-12 gap-x-4 gap-y-10 w-full">
      <!-- BEGIN Reconnaissance handicap -->
      
      <multiple-field
        :value="form.travailleur_handicape"
        class="col-span-full md:col-span-6 place-self-start"
        label="Etes-vous reconnu comme travailleur handicapé ?"
      />

      <div
        class="col-span-full"
      >
        <div class="grid grid-cols-12 gap-x-4 gap-y-10 w-full">
          <multiple-field
            class="col-span-full md:col-span-6"
            :value="form.handicap"
            label="Type de handicap"
          />

          <multiple-field
            class="col-span-full md:col-span-6"
            :value="form.lourdeur_handicap"
            label="Reconnaissance lourdeur de handicap"
          />

          <multiple-field
            class="col-span-full md:col-span-6"
            :value="form.handicap_precis"
            label="Autre handicap"
          />
        </div>
        <!-- BEGIN list type reconnaissance -->
        <div
          v-for="(type, i_t) in form.type_reconnaissance.value"
          :key="i_t"
          class="transition-all duration-300 flex items-center justify-center my-10"
        >
          <div class="grid grid-cols-12 gap-x-4 gap-y-10 w-full">
            <div class="col-span-full md:col-span-6 flex space-x-4">
              <multiple-field
                :value="type.value.statut"
                class="mr-4 flex-shrink flex-initial"
                label="Type de reconnaissance"
              />
            </div>

            <!-- BEGIN Only for desktop -->
            <div class="hidden lg:flex col-start-auto col-span-6">
              <multiple-field
                :value="type.value.cdaph"
                class="mr-4 flex-shrink flex-initial"
                label="Numéro de dossier"
              />

              <multiple-field
                :value="type.value.cdaph_validite"
                label="Fin de validité"
              />
            </div>
            <!-- END Only for desktop -->
            <!-- BEGIN Only for mobile devices -->
            <multiple-field
              :value="type.value.cdaph"
              class="lg:hidden col-span-full"
              label="Numéro de dossier"
            />

            <multiple-field
              :value="type.value.cdaph_validite"
              class="lg:hidden col-span-full"
              label="Fin de validité"
            />
            <!-- END Only for mobile devices -->
          </div>
        </div>
        <!-- END list type reconnaissance -->

        <!-- BEGIN Tutelle ou curatelle -->
        <div class="grid grid-cols-12 gap-x-4 gap-y-10">
          <multiple-field
            :value="form.tutelle"
            class="lg:col-start-1 col-span-full md:col-span-6"
            label="Tutelle ou Curatelle"
          />


          <div
            class="md:col-span-full grid grid-cols-12 gap-x-4 gap-y-10"
          >
            <multiple-field
              :value="form.tutelle_precis"
              class="md:col-span-4"
              label="Précisez"
            />


            <multiple-field
              :value="form.tutelle_autre"
              class="md:col-span-4"
              label="Autre"
            />

            <multiple-field
              :value="form.tutelle_personne"
              class="md:col-span-4"
              label="Personne ou organisme"
            />
          </div>
        </div>
        <!-- END tutelle ou curatelle -->
      </div>
      <!-- END Reconnaissance handicap -->

      <multiple-field
        :value="form.organisme_prescripteur"
        class="lg:col-start-1 md:col-span-4"
        label="Organisme prescripteur"
      />

      <multiple-field
        :value="form.nom_referent"
        class="md:col-span-4"
        label="Nom du référent"
      />

      <multiple-field
        :value="form.tel_referent"
        class="md:col-span-4"
        label="Tél"
      />

      <multiple-field
        :value="form.organisme_social"
        class="md:col-span-4"
        label="Organisme référent"
      />

      <multiple-field
        :value="form.nom_referent_social"
        class="md:col-span-4"
        label="Nom du référent"
      />

      <multiple-field
        :value="form.tel_referent_social"
        class="md:col-span-4"
        label="Tél"
      />

      <multiple-field
        :value="form.situation_emploi"
        class="lg:col-start-1 md:col-span-6 col-span-full"
        label="Situation actuelle par rapport à l'emploi"
      />

      <multiple-field
        :value="form.situation_emploi_precis"
        class="md:col-span-6"
        label="Autre situation par rapport à l'emploi"
      />

      <div class="col-span-full flex items-end space-x-4">
        <multiple-field
          :value="form.pole_emploi"
          class="w-6/12 md:w-3/12"
          label="Etes-vous inscrit à Pôle Emploi ?"
        />
        <multiple-field
          :value="form.numero_pole_emploi"
          label="N° demandeur d'emploi"
          class="w-6/12"
        />
      </div>
      <multiple-field
        :value="form.emploi"
        class="lg:col-start-1 md:col-span-4 col-span-full"
        label="Emploi (ou projet professionnel)"
      />
      <multiple-field
        :value="form.structure"
        class="md:col-span-4"
        label="Nom de la structure actuelle"
      />

      <multiple-field
        :value="form.date_structure"
        class="col-span-full md:col-span-4"
        label="Date d'entrée dans la structure"
      />

      <multiple-field
        class="lg:col-start-1"
        :class="{
          'md:col-span-6': form.situation_anterieure.value === 'Autre',
          'md:col-span-3': form.situation_anterieure.value !== 'Autre',
        }"
        :value="form.situation_anterieure"
        label="Situation antérieure à l'entrée dans la structure"
      />


      <multiple-field
        :value="form.situation_anterieure_precis"
        class="md:col-span-3"
        label="Autre situation antérieure"
      />

      <multiple-field
        :value="form.referent"
        class="md:col-span-6"
        label="Référent (ou responsable hiérarchique)"
      />

      <multiple-field
        :value="form.conditions1"
        class="col-span-full md:col-span-6 lg:col-start-1 row-span-2"
        label="Conditions de travail recherchées (préconisation)"
        grows-vertically
      />
      <multiple-field
        :value="form.conditions2"
        class="col-span-full md:col-span-6 row-span-2"
        label="Recommandations et propositions de mesures individuelles"
        grows-vertically
      />
    </div>
    <!-- END Informations générales -->

    <h3
      id="form-contacts"
      class="my-16 xxl:my-20 2xl:my-22 w-full"
    >
      Personnes à contacter <br>en cas d'urgence
    </h3>

    <!-- BEGIN Personnes à contacter -->
    <div v-if="form.proches.value.length > 0">
      <!-- to refresh list when remove last item (reset values because non reactive element) -->
      <div
        v-for="(proche, index) in form.proches.value"
        :key="index"
        class="transition-all duration-300 flex flex-col space-y-10 mb-10"
      >
        <div class="grid grid-cols-10 gap-x-4 gap-y-10 w-full">
          <div class="col-span-10 md:col-span-4 flex space-x-4">
            <multiple-field
              :value="proche.value.prenom_proche"
              label="Prénom"
            />
          </div>

          <multiple-field
            :value="proche.value.nom_proche"
            class="md:col-span-3"
            label="Nom"
          />
          <div class="col-span-full md:col-span-3 grid grid-cols-2 gap-x-4">
            <multiple-field
              class="md:col-span-full"
              :value="proche.value.relation_proche"
              label="Relation"
            />

            <multiple-field
              :value="proche.value.relation_proche_precis"
              class="md:col-span-full"
              label="Autre relation"
              name="relation_proche_precis"
            />
          </div>
          <multiple-field
            :value="proche.value.adresse_proche"
            class="md:col-span-4 row-span-3"
            label="Adresse complète"
            grows-vertically
          />

          <multiple-field
            :value="proche.value.telephone_proche"
            class="md:col-span-3"
            label="Téléphone"
          />

          <multiple-field
            :value="proche.value.mail_proche"
            class="md:col-span-3"
            label="Mail"
          />
        </div>
        <div
          v-if="index < form.proches.value.length - 1"
          class="w-full border-b border-gray-600"
        />
      </div>
    </div>
    <!-- END Personnes à contacter -->
  </div>
</template>
<script>
import MultipleField from '../../MultipleField.vue';


export default {
  name: 'InformationsGeneralesAudit',
  components: {
    MultipleField,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  methods: {
  },
};
</script>